// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentPageTitle_container__anoi3"};